module.exports = __webpack_public_path__ + "static/media/data-storage-1.28e77920.jpg";